import React from "react";
import { Nav, NavLink, NavMenu, NavWrapper } from "./Navbar/BottomNavbarElements.jsx";
import Stack from '@mui/material/Stack';

const BottomNavbar = ({currentLocation}) => {
    if (currentLocation.startsWith("/admin")){
            return
    }
    switch(currentLocation){
        case "/businessHome":
            return
        case "/successPage":
            return
        case "/newEntry":
            return
        case "/about":
            return
        case "/resources":
            return
         case "/form":
            return
        case "/accessCode":
            return
        case "/accesscode":
            return
        case "/home":
            return (
                <NavWrapper >
                    <Nav style={{backgroundColor:"grey"}}>
                        <NavMenu>
                            <NavLink to="/contactUS" activeStyle>
                                Contact
                            </NavLink>
                            <NavLink to="/resources" activeStyle>
                                Consultants
                            </NavLink>
                            <NavLink to="/FAQ" activeStyle>
                                FAQ
                            </NavLink>
                            <NavLink to="/privacyPolicy" activeStyle>
                                Privacy Policy
                            </NavLink>
                            <NavLink to="/terms" activeStyle>
                                Terms
                            </NavLink>
                        </NavMenu>
                    </Nav>
                </NavWrapper>
            );

        default:
            return (
                <NavWrapper>
                    <Nav>
                        <NavMenu>
                            <NavLink to="/contactUS" activeStyle>
                                Contact
                            </NavLink>
                            <NavLink to="/resources" activeStyle>
                                Consultants
                            </NavLink>
                            <NavLink to="/FAQ" activeStyle>
                                FAQ
                            </NavLink>
                            <NavLink to="/privacyPolicy" activeStyle>
                                Privacy Policy
                            </NavLink>
                            <NavLink to="/terms" activeStyle>
                                Terms
                            </NavLink>
                        </NavMenu>
                    </Nav>
                </NavWrapper>
            );
};
}

export default BottomNavbar;